/**
 * How the recording in progress was started, for analytics only. The outcome events (Submit,
 * cancel, draft) fire far from the start button, so the starter records it here against the
 * recording's id and they read it back: in PostHog, ``start_source`` splits every outcome by
 * entry point and ``recording_id`` joins it to its ``quick_start_started``.
 *
 * - ``quick_start``: the Start card's one-click patient and template.
 * - ``record_first``: one click with no template (Start Encounter on a record-first account, or
 *   "Record without a patient").
 * - ``drawer``: the Start Encounter drawer.
 * - ``unknown``: a recording this page did not start (resumed after a reload).
 */
export type CaptureStartSource = "quick_start" | "record_first" | "drawer";

let current: { recordingId: string; source: CaptureStartSource; startedAt: number } | null = null;

export const markCaptureStart = (recordingId: number | string, source: CaptureStartSource): void => {
  current = { recordingId: String(recordingId), source, startedAt: Date.now() };
};

/** ``start_source``, ``recording_id`` and ``seconds_since_start`` for an event about this recording. */
export const captureStartProperties = (recordingId: number | string | null | undefined) => {
  const id = recordingId == null || recordingId === "" ? null : String(recordingId);
  const known = id !== null && current?.recordingId === id ? current : null;
  return {
    start_source: known?.source ?? "unknown",
    recording_id: id,
    seconds_since_start: known ? Math.round((Date.now() - known.startedAt) / 1000) : null,
  };
};
